<template>
  <div class="other">
    <div class="habitat-destruction">
      <div class="title">
        <h4>Ways you can make a difference with habitat destruction</h4>
      </div>

      <div class="differences">
        <div class="difference">
          <img
            src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/img-help-wildlife-neighbourhood.jpeg"
            alt="picture"
          />
          <p>
            <a
              href="https://www.wwf.org.au/news/blogs/9-australian-native-plants-and-trees-to-attract-wildlife-and-bees-to-your-apartment-balcony-or-garden"
              target="_blank"
              >Plant native trees</a
            >
            and shurbs to create a wildlife-friendly oasis.
          </p>
        </div>
        <div class="difference">
          <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/img-plant-trees.jpeg" alt="picture" />
          <p>
            <a
              href="https://www.wwf.org.au/news/blogs/10-easy-ways-you-can-help-wildlife-right-now"
              target="_blank"
              >Learn easy tips</a
            >
            on how you can help wildlife in your neighbourhood.
          </p>
        </div>
        <div class="difference">
          <img
            src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/img-scat-chat-with-wwf-1000px.jpg"
            alt="picture"
          />
          <p>
            <a
              href="https://www.wwf.org.au/get-involved/scat-chat"
              target="_blank"
              >Tune into Scat Chat</a
            >
            to get to the bottom of amazing things animal scat (or poo) can
            teach us about the environment. Hosted by comedian Carlo Ritchie.
          </p>
        </div>
      </div>
    </div>

    <div class="endangered-species">
      <div class="header">
        <h4>Other animals at risk of extinction in your area:</h4>
      </div>

      <div class="separator"></div>

      <div class="species">
        <p class="animal" v-for="animal in species" :key="animal">
          {{ animal }}
        </p>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "Other",

  data() {
    return {
      species: [],
    };
  },

  computed: {
    electorate() {
      return this.$store.getters.electorateName;
    },
  },

  watch: {
    async electorate() {
      this.species = await this.getSpecies();
    },
  },

  async created() {
    this.species = await this.getSpecies();
  },

  methods: {
    async getSpecies() {      
      return (
        await this.$store.dispatch("getSpecies", {
          electoraldivisionname: this.$store.getters.electorateName,
          isfeatured: true,
          ishero: false,
        })
      )
        .slice(0, 5)
        .filter(e => e.commonname)
        .map((e) => e.commonname);
    },
  },
};
</script>

<style scoped>
.other {
  display: flex;
  flex-direction: column;
  gap: 54px;
}

.habitat-destruction,
.endangered-species {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.habitat-destruction .differences {
  display: flex;
  justify-content: center;
  gap: 64px;
  width: 100%;
}

.habitat-destruction .difference {
  display: flex;
  flex-direction: column;
  max-width: 200px;
  gap: 18px;
}

.habitat-destruction .difference img {
  width: 100%;
  height: 128px;
}

.habitat-destruction .difference p {
  text-align: center;
}

.endangered-species {
  gap: 32px;
}

.endangered-species .header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.endangered-species .header p {
  font-size: 20px;
}

.endangered-species .separator {
  border: 1px solid var(--black);
  width: 20%;
}

.endangered-species .species {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  width: 90vw;
}

h4 {
  margin: 0px;
  color: #1e1e1e;
  font-size: 24px;
  font-weight: 900;
  line-height: 40px;
  text-transform: uppercase;
  text-align: center;
}

a {
  text-decoration: none;
  color: var(--black);
}

a,
b {
  font-weight: 800;
}

@media screen and (max-width: 800px) {
  .differences {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .habitat-destruction .difference {
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: none;
  }

  .habitat-destruction .difference img {
    height: 350px;
  }
}

@media screen and (max-width: 450px) {
  .habitat-destruction .difference img {
    height: 250px;
  }
}
</style>


// WEBPACK FOOTER //
// Other.vue?6c07cbfa